import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { SearchResultSkeleton } from '../search-result-skeleton';

const resultsListGridAreaStyles = xcss({
	gridArea: 'results-list',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
});

export const ResultsLoading: ({
	rowCount,
}: {
	rowCount?: number | undefined;
}) => React.JSX.Element = ({ rowCount = 7 }): React.JSX.Element => {
	return (
		<Box role="list" xcss={resultsListGridAreaStyles} testId="search-page-results-loading">
			{Array.from({ length: rowCount }).map((_, index) => (
				<SearchResultSkeleton key={index} />
			))}
		</Box>
	);
};
